/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { TableColumnsType } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { ModelBankBalanceDetail } from 'account-client'
import dayjs from 'dayjs'
import { useTranslateAmount } from '@/hooks/useTranslateAmount'
import { useTranslateEnum } from '@/hooks/useTranslateEnum'
import { RemittanceDetails } from '@/pages/billing/IncomeExpense/CashDetails/RemittanceDetails'
import { BankBalanceDetailType } from '@/pages/billing/interface'
import { timeFormatter } from '@/utils/timeFormatter'

export function useCashDetailsColumns() {
  const { t } = useTranslation()
  const { translate } = useTranslateEnum()
  const { contractId } = useParams()
  const { currency } = useTranslateAmount()

  const columns = useMemo<TableColumnsType<ModelBankBalanceDetail>>(
    () => [
      {
        title: t('Traded on'),
        dataIndex: 'gmtTime',
        sorter: true,
        width: 160,
        render: date => timeFormatter.format(date),
      },
      {
        title: `${t('Cash Balance')}（${currency}）`,
        dataIndex: 'newBalanceFormatted',
        width: 130,
      },
      {
        title: t('Type'),
        dataIndex: 'type',
        width: 100,
        render: value => translate(value),
      },
      {
        title: `${t('Deposit Amount')}（${currency}）`,
        dataIndex: 'type',
        render: (value, record) => (value === BankBalanceDetailType.deposit ? record.amountFormatted : '-'),
      },
      {
        title: `${t('Deduct Amount')}（${currency}）`,
        dataIndex: 'type',
        render: (value, record) => (value === BankBalanceDetailType.deduct ? record.amountFormatted : '-'),
      },
      {
        title: `${t('Withdraw Amount')}（${currency}）`,
        dataIndex: 'type',
        render: (value, record) => (value === BankBalanceDetailType.withdraw ? record.amountFormatted : '-'),
      },
      {
        title: t('Deduction Statement'),
        dataIndex: 'type',
        // width: 100,
        render: (value, record) =>
          value === BankBalanceDetailType.deduct ? (
            <Link to={`/billing-center/${contractId}/statements/${record.memo.statementID}`}>
              {timeFormatter.format(record.memo.statementStart as any, 'yearMonth')}
            </Link>
          ) : (
            '-'
          ),
      },
      {
        title: t('Recharge Info'),
        dataIndex: 'type',
        // width: 210,
        render: (value, record) => (value === BankBalanceDetailType.deposit ? <RemittanceDetails bankBalanceDetailData={record} /> : '-'),
      },
    ],
    [],
  )

  return columns
}
